export const OPERATION_MODE_STATUS = [
  {
    value: '手动导入',
    label: '手动导入',
  },
  {
    value: '自动导入',
    label: '自动导入',
  },
  {
    value: '手动移出',
    label: '手动移出',
  },
  {
    value: '自动移出',
    label: '自动移出',
  },
  {
    value: '手动改价',
    label: '手动改价',
  }
]

export const PROD_MODIFY_STATUS = [
  {
    label:'成功',
    value:1
  },
  {
    label:'失败',
    value:2
  },
]
export const PROD_MODIFY_OPERATE_SUB_TYPE = [
  {
    label:'同步erp商品库存',
    value:36
  }
]